<template>
    <v-dialog v-model="modal"  max-width="600px" persistent>
        <v-card>
            <v-card-title primary-title> พบข้อผิดพลาด </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-container>
                    <v-row v-if="$route.params.url">
                        <v-col cols="3">
                            <v-label>Service url : </v-label>
                        </v-col>
                        <v-col cols="9">
                            <v-label>{{$route.params.url}}</v-label>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-label>Status : </v-label>
                        </v-col>
                        <v-col cols="9">
                            <v-label>{{$route.params.status}}</v-label>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-label>Message : </v-label>
                        </v-col>
                        <v-col cols="9">
                            <v-label>{{$route.params.errorMessage}}</v-label>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-on:click="close">ปิด</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Login',
    data: () => ({
        modal: true
    }),
    methods: {
        close() {
            this.modal = false;
            this.$router.go(-1);
        }
    }
}
</script>